import React from 'react';
import styled from '@emotion/native';
import { Image } from 'react-native';
import { accent, green } from '@/shared/styles/colors';

interface TermsToggleProps {
  checked: boolean;
}

const TermsToggle: React.FC<TermsToggleProps> = ({ checked }) => {
  return (
    <Container checked={checked}>
      {checked && (
        <CheckmarkImage
          source={require('../../assets/images/CheckMarkWhite.png')}
          resizeMode="contain"
          tintColor={accent}
        />
      )}
    </Container>
  );
};

const Container = styled.View<{
  checked: boolean;
}>(({ checked }) => ({
  width: 30,
  height: 30,
  borderRadius: 15,
  borderWidth: 1,
  borderColor: green,
  backgroundColor: checked ? green : 'transparent',
  justifyContent: 'center',
  alignItems: 'center',
}));

const CheckmarkImage = styled(Image)({
  width: 20,
  height: 20,
});

export default TermsToggle;
